module.exports = __webpack_public_path__ + "img/book-vertical_fill.85849983.svg";